import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import FileProgress from '../components/FileProgress'
import * as FileUploadState from '../modules/fileUpload'

export default connect(
  (state: ApplicationState) => {
    const fileUploadState = FileUploadState.selectAllState(state)

    return fileUploadState as FileUploadState.IFileUploadState
  },
  FileUploadState.actionCreators,
)(FileProgress)
